import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import Select from 'react-select';

const CasesField = ({ caseTypeSelectOptions }) => {
  return (
    <Field name="case_type" parse={values => values.map(({ value }) => value)}>
      {({ input }) => (
        <Fragment>
          <label>Type</label>
          <Select {...input} multi options={caseTypeSelectOptions} className="form-select" />
        </Fragment>
      )}
    </Field>
  );
};

CasesField.propTypes = {
  caseTypeSelectOptions: PropTypes.array.isRequired,
};

export default CasesField;



// WEBPACK FOOTER //
// ./src/components/advancedSearch/fields/TypeField.jsx